import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useRef, useEffect } from 'react';
import Style from "./css/style.module.css";
import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import PlanCalendarArea from "./area/calendar";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ViewTodoDaySortPopup from "./area/popup/view_todo_day_sort";
import WriteTodoArrPopup from "@/pages/comp/plan/calendar/area/popup/write_todo_arr";
import WriteTodoPopup from "@/pages/comp/plan/todo/popup/write";
import ViewTodoWordPrintPopup from "@/pages/comp/plan/todo/popup/view_todo_word_print";
import DelSelectTodoPopup from "@/pages/comp/plan/calendar/area/popup/del_select_todo";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import { useLocation } from "react-router";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";

function PlanCalendarPage() {
  const { state } = useLocation();
  let page_state: any = {
    stu_seq_arr: [],
    stu_info_arr: [],
    ...state
  };
  const [select_stu_info, set_select_stu_info] = useState<any>(null);
  const StuSearchListRef = useRef<any>(null);
  const PlanCalendarAreaRef = useRef<any>(null);
  const left_box_scroll_ref = useRef<any>(null);
  const right_box_ref = useRef<any>(null);
  const [stu_list_opt, set_stu_list_opt] = useState<any>({});
  const search_plan_todo = (inData: any) => {
    PlanCalendarAreaRef.current.list(inData);
  };

  useEffect(() => {
    if (StuSearchListRef.current) {
      set_stu_list_opt(StuSearchListRef.current.getListOpt());
    }
  }, []);

  useEffect(() => {
    if (!strFunc.is_empty(page_state.stu_seq_arr)) {
      if (PlanCalendarAreaRef.current) {
        search_plan_todo({
          "s_stu_user_seq": page_state.stu_seq_arr,
          "s_stu_info_arr": page_state.stu_info_arr,
        });
      }
      if (StuSearchListRef.current) {
        StuSearchListRef.current.go_select_by_select_seq_arr({
          select_seq_arr: page_state.stu_seq_arr
        });
      }
    }
  }, []);

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "todo_day_sort",//view
    rowData: {},
    isUpdate: false,
    select_stu_name: "",
    select_stu_seq: "",
    select_date: "",
    todo_info: {},
    todo_pri_val_arr: [],
    title: "맞춤플랜 보기",
    width: "900px",
    height: "100%",
  });

  const openTodoDaySort = (inData: any) => {
    let opt_obj = {
      select_stu_name: "",
      select_stu_seq: "",
      select_date: "",
      ...inData
    };
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "todo_day_sort",
      title: "",
      ...opt_obj
    });
  };
  const openTodoWritePopup = (inData: any) => {
    let opt_obj = {
      select_stu_name: "",
      select_stu_seq: [],
      select_date: "",
      ...inData
    };
    if (StuSearchListRef.current) {
      let select_stu_seq_arr = [];
      let select_stu_arr = StuSearchListRef.current.get_select_arr();
      for (let i = 0; i < select_stu_arr.length; i++) {
        select_stu_seq_arr.push(select_stu_arr[i]["a_seq"]);
      }
      opt_obj.select_stu_seq = select_stu_seq_arr;
    } else {
      opt_obj.select_stu_seq = [];
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "todo_write",
      title: "맞춤플랜 작성",
      ...opt_obj
    });
  };
  const openTodoWriteOnePopup = (inData: any) => {
    let opt_obj = {
      select_date: "",
      todo_info: {},
      ...inData
    };
    if (strFunc.is_empty(opt_obj["todo_info"]["a_seq"])) {
      alert("내용 없음.");
      return false;
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "todo_write_one",
      todo_info: opt_obj["todo_info"],
      isUpdate: true,
      title: "맞춤플랜",
      ...opt_obj
    });
  };
  const openTodoWordPrintPopup = (inData: any) => {
    let opt_obj = {
      todo_pri_val_arr: [],
      ...inData
    };
    if (opt_obj["todo_pri_val_arr"].length == 0) {
      alert("내용 없음.");
      return false;
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "todo_word_print",
      todo_pri_val_arr: opt_obj["todo_pri_val_arr"],
      title: "단어학습 프린트",
      ...opt_obj
    });
  };
  const openDelSelectTodoPopup = (inData: any) => {
    let opt_obj = {
      todo_pri_val_arr: [],
      list_opt: {},
      ...inData
    };
    if (opt_obj["todo_pri_val_arr"].length == 0) {
      alert("내용 없음.");
      return false;
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "del_select_todo",
      todo_pri_val_arr: opt_obj["todo_pri_val_arr"],
      list_opt: opt_obj["list_opt"],
      title: "맞춤플랜 삭제",
      ...opt_obj
    });
  };

  const removeSelectStu = (stu_seq: any) => {
    if (StuSearchListRef.current) {
      StuSearchListRef.current.setSelectFalseByUserSeq({
        user_seq_arr: [stu_seq],
      });
    }
    if (select_stu_info != null && select_stu_info["a_seq"] == stu_seq) {
      set_select_stu_info(null);
      if (PlanCalendarAreaRef.current) {
        search_plan_todo({
          "s_stu_user_seq": [],
          "s_stu_info_arr": [],
        });
      }
    }
  };

  return (
    <CompLayout isConTitle={false}>
      {stu_list_opt.s_user_name_like != undefined &&
        <SearchArea
          listOpt={stu_list_opt}
          setListOpt={(inData: any) => {
            if (StuSearchListRef.current) {
              StuSearchListRef.current.setListOpt(inData);
              set_stu_list_opt(inData);
            }
          }}
          list={(inData: any) => {
            if (StuSearchListRef.current) {
              StuSearchListRef.current.list(inData);
              set_stu_list_opt({
                ...stu_list_opt,
                ...inData
              });
            }
          }}
        ></SearchArea>
      }
      <div className={Style.wrap}>
        <div className={Style.left_box} >
          <div ref={left_box_scroll_ref}>
            <FindStudentList
              ref={StuSearchListRef}
              listOpt={{
                num_per_page: 20,
                s_addon_todo: "1",
                ...stu_list_opt,
              }}
              grid_opt={{
                is_add_checkbox: false,
                rowMultiSelectWithClick: false,
                height: "",
                domLayout: "autoHeight",
              }}
              show_key_arr={["row_view_plan"]}
              is_show_title={false}
              is_show_search_area={false}
              list={(inData: any) => {
                search_plan_todo({
                  s_stu_user_seq: inData.s_stu_user_seq,
                  s_stu_info_arr: inData.select_stu_info_arr,
                });
                if (inData.select_stu_info_arr.length > 0) {
                  set_select_stu_info({
                    ...inData.select_stu_info_arr[0],
                  });
                } else {
                  set_select_stu_info(null);
                }
              }}
            ></FindStudentList>
          </div>
        </div>
        <div className={Style.cal_box}>
          <div ref={right_box_ref}>
            <PlanCalendarArea
              ref={PlanCalendarAreaRef}
              openTodoDaySort={openTodoDaySort}
              openTodoWritePopup={openTodoWritePopup}
              openTodoWordPrintPopup={openTodoWordPrintPopup}
              openDelSelectTodoPopup={openDelSelectTodoPopup}
              removeSelectStu={removeSelectStu}
              onSearchDateChange={(inData: any) => {
                if (StuSearchListRef.current) {
                  StuSearchListRef.current.list({
                    // s_addon_todo_start_date: DateFunc.get_date_format(new Date(inData), "Y-m-01"),
                    // s_addon_todo_end_date: DateFunc.get_date_format(new Date(inData), "Y-m-t"),
                    s_addon_todo_start_date: inData,
                    s_addon_todo_end_date: inData,
                  });
                }
              }}
            ></PlanCalendarArea>
          </div>
        </div>
      </div>
      <RightScrollFix right_ref={left_box_scroll_ref} limit_scroll_top={350} ></RightScrollFix>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} title_bar_style={{ borderBottom: 0 }}
          content_div_style={{ padding: "10px 0px", paddingBottom: 85 }} y={"0"}>
          {popupData.sort == "todo_day_sort" &&
            <ViewTodoDaySortPopup
              list_opt={{
                "s_stu_user_name": popupData.select_stu_name,
                "s_stu_user_seq": popupData.select_stu_seq,
                "s_start_date": popupData.select_date,
                "s_end_date": popupData.select_date,
              }}
              list={(inData: any) => {
                search_plan_todo(inData);
                if (StuSearchListRef.current) {
                  StuSearchListRef.current.list({});
                }
              }}
              openTodoWriteOnePopup={openTodoWriteOnePopup}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewTodoDaySortPopup>
          }
          {popupData.sort == "todo_write" &&
            <WriteTodoArrPopup
              select_date={popupData.select_date}
              stu_seq_arr={strFunc.is_empty(popupData.select_stu_seq) ? [] : popupData.select_stu_seq}
              calback={(inData: any) => {
                search_plan_todo({});
                if (StuSearchListRef.current) {
                  StuSearchListRef.current.list({});
                }
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTodoArrPopup>
          }
          {popupData.sort == "todo_write_one" &&
            <WriteTodoPopup
              rowData={popupData.todo_info}
              isUpdate={popupData.isUpdate}
              callback={(inData: any) => {
                search_plan_todo({});
                if (StuSearchListRef.current) {
                  StuSearchListRef.current.list({});
                }
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTodoPopup>
          }
          {popupData.sort == "todo_word_print" &&
            <ViewTodoWordPrintPopup
              todo_pri_val_arr={popupData.todo_pri_val_arr}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewTodoWordPrintPopup>
          }
          {popupData.sort == "del_select_todo" &&
            <DelSelectTodoPopup
              todo_pri_val_arr={popupData.todo_pri_val_arr}
              refreshData={(inData: any) => {
                search_plan_todo({});
                if (StuSearchListRef.current) {
                  StuSearchListRef.current.list({});
                }
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></DelSelectTodoPopup>
          }
        </LayerPopup>
      }
    </CompLayout>
  );
}

export default PlanCalendarPage;